/**
 * Copyright: Sensorete
 * Created by PhpStorm.
 * User: Luigi Montella Velluti - bronz@sensorete.net
 * Date: 03/01/24
 * Time: 18:42
 */
import Cookies from "js-cookie";

export default () => {
    let last_seen = Cookies.get('m6e-newsletter-rotate');
    let the_choice = 0;
    let the_cookie_expire_days = 3;

    if (typeof last_seen == 'undefined') {
        let rand_sem = Math.random();
        the_choice = (rand_sem > 0.5 ? 1 : 0);
    } else {
        the_choice = (last_seen == 1 ? 0 : 1);
    }

    let class_idx = 'mailing-list-' + (the_choice + 1);
    let newsletter_box_list = document.getElementsByClassName(class_idx);
    if(newsletter_box_list.length > 0){
        document.getElementsByClassName(class_idx)[0].classList.remove('is-hidden');
        Cookies.set('m6e-newsletter-rotate', the_choice, {expires: the_cookie_expire_days});
    }
}
